import { frontendURL } from '../../../../helper/URLHelper';

import ServicesIndex from './Index.vue';
import ServiceForm from './ServiceForm.vue';
import SettingsContent from '../Wrapper.vue';
import SettingsWrapper from '../SettingsWrapper.vue';

export default {
  routes: [
    {
      path: frontendURL('accounts/:accountId/settings/services'),
      component: SettingsWrapper,
      children: [
        {
          path: '',
          redirect: to => {
            return { name: 'settings_services_list', params: to.params };
          },
        },
        {
          path: 'list',
          name: 'settings_services_list',
          component: ServicesIndex,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
    {
      path: frontendURL('accounts/:accountId/settings/services'),
      component: SettingsContent,
      props: () => {
        return {
          headerTitle: 'SERVICES_SETTINGS.HEADER',
          icon: 'settings',
          showBackButton: true,
        };
      },
      children: [
        {
          path: 'new',
          name: 'settings_services_new',
          component: ServiceForm,
          meta: {
            permissions: ['administrator'],
          },
        },
        {
          path: 'edit/:id',
          name: 'settings_services_edit',
          component: ServiceForm,
          meta: {
            permissions: ['administrator'],
          },
        },
      ],
    },
  ],
};
